import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import CreaComentarios from "./CreaComentariosMenu";
import Cookies from "universal-cookie";

import Pruebas from "./PruebaHtmlPdf";

import ReasignarJuridico from "./ReasignarJuridico";
import MDBox from "components/MDBox";
import { Grid } from "@mui/material";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDTypography from "components/MDTypography";
import OtrosSi from "./OtrosSi";
import AnexosAbastecimiento from "./VerAnexosAbastecimiento";

const SolicitudesAbastecimiento = () => {
  const cookie = new Cookies();
  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [switchState, setSwitchState] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Puedes ajustar la cantidad de elementos por página
  const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda general
  const [modalOpen, setModalOpen] = useState(false); // Estado para el modal
  const [selectedItem, setSelectedItem] = useState(null); // Para el ítem seleccionado

  useEffect(() => {
    const fetchCasosAsignados = async () => {
      try {
        const response = await axios({
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          method: "get",
          url: `https://contratosback.azurewebsites.net/api/v1/ObtenerCasosAsignados/${cookie.get(
            "id"
          )}`,
        });

        const newData = response.data;

        // Comparar el nuevo JSON con el estado actual (list1)
        if (JSON.stringify(newData) !== JSON.stringify(list1)) {
          setList1(newData); // Actualizar la tabla si hay cambios

          // Actualizar el estado del switch si es necesario
          const updatedSwitchState = {};
          newData.forEach((item) => {
            updatedSwitchState[item.id] = item.aprobacionTecnica == 1;
          });
          setSwitchState(updatedSwitchState);
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Configurar el temporizador para ejecutar fetchCasosAsignados cada 30 segundos
    const intervalId = setInterval(() => {
      fetchCasosAsignados();
    }, 3000); // 30,000 ms = 30 segundos

    return () => clearInterval(intervalId); // Limpiar el temporizador al desmontar el componente
  }, [list1, cookie]);

  const formatDate = (dateString) => {
    return dateString.split("T")[0];
  };

  // Filtrar datos usando el término de búsqueda general
  const filteredItems = list1.filter((item) => {
    const lowercasedFilter = searchTerm.toLowerCase();
    return (
      item.id.toString().includes(lowercasedFilter) ||
      item.fecha.includes(lowercasedFilter) ||
      item.nombreProveedor.toLowerCase().includes(lowercasedFilter) ||
      item.nit.toLowerCase().includes(lowercasedFilter) ||
      item.direccion.toLowerCase().includes(lowercasedFilter) ||
      item.ciudad.toLowerCase().includes(lowercasedFilter) ||
      item.telefono.toLowerCase().includes(lowercasedFilter)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const openModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={12} pb={12}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={12}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Solicitudes Jurídicas
                  </MDTypography>
                </MDBox>

                {/* Buscador general */}
                <div className="px-4 py-2">
                  <input
                    type="text"
                    placeholder="Buscar..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-control"
                  />
                </div>

                <hr />
                <Table
                  className="align-items-center"
                  style={{ marginLeft: "20px", fontSize: "14px", color: "#a7a7a7" }} // <- aquí defines color y tamaño de letra
                  responsive
                >
                  <thead style={{ color: "#a7a7a7" }}>
                    <tr>
                      <th style={{ color: "#a7a7a7" }}>Menú Acciones</th>

                      <th style={{ color: "#a7a7a7" }}>N° Contrato</th>
                      <th style={{ color: "#a7a7a7" }}>Contrato OtrosSi</th>
                      <th style={{ color: "#a7a7a7" }}>Tipo De Contrato</th>
                      <th style={{ color: "#a7a7a7" }}>Fecha</th>
                      <th style={{ color: "#a7a7a7" }}>Paso Aprobación</th>
                      <th style={{ color: "#a7a7a7" }}>Nombre Del Proveedor</th>
                      <th style={{ color: "#a7a7a7" }}>N° Documento</th>
                      <th style={{ color: "#a7a7a7" }}>Dirección</th>
                      <th style={{ color: "#a7a7a7" }}>Ciudad</th>
                      <th style={{ color: "#a7a7a7" }}>Teléfono</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: "#a7a7a7" }}>
                    {currentItems.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <Button color="primary" onClick={() => openModal(item)}>
                            Acciones
                          </Button>
                        </td>

                        <td style={{ color: "#a7a7a7" }}>{item.id}</td>
                        <td>
                          <OtrosSi numContrato={item.numeroContrato} />
                        </td>
                        <td style={{ color: "#a7a7a7" }}>{item.tipoContrato}</td>
                        <td style={{ color: "#a7a7a7" }}>{formatDate(item.fecha)}</td>
                        <td style={{ color: "#a7a7a7" }}>
                          {item.descripcion}
                          <br></br>
                          {item.nombre}
                        </td>
                        <td style={{ color: "#a7a7a7" }}>{item.nombreProveedor}</td>
                        <td style={{ color: "#a7a7a7" }}>{item.nit}</td>
                        <td style={{ color: "#a7a7a7" }}>{item.direccion}</td>
                        <td style={{ color: "#a7a7a7" }}>{item.ciudad}</td>
                        <td style={{ color: "#a7a7a7" }}>{item.telefono}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination className="pagination justify-content-end mb-0">
                      {Array.from({ length: totalPages }, (_, index) => (
                        <PaginationItem key={index} active={currentPage === index + 1}>
                          <PaginationLink onClick={() => paginate(index + 1)}>
                            {index + 1}
                          </PaginationLink>
                        </PaginationItem>
                      ))}
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </DashboardLayout>
      {/* Modal de acciones */}
      <Modal isOpen={modalOpen} toggle={closeModal}>
        <ModalHeader toggle={closeModal}>Acciones</ModalHeader>
        <ModalBody>
          {selectedItem && (
            <>
              {/* Contenedor para los botones, usando flexbox con dirección en columna */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <CreaComentarios id={selectedItem.id} paso={selectedItem.pasoAprobacion} />
                <AnexosAbastecimiento id={selectedItem.id} />

                {cookie.get("tipo_Usuario") == 1 ||
                cookie.get("tipo_Usuario") == 4 ||
                cookie.get("tipo_Usuario") == 3 ? (
                  <ReasignarJuridico id={selectedItem.id} />
                ) : (
                  <h></h>
                )}
                <Pruebas id={selectedItem.id} />
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default SolicitudesAbastecimiento;
